import { OrderTypeEnum } from '@@fire-b2b/types/order/OrderTypeEnum'
import { normalizeRouteName } from '@fire-b2b/utils/helpers'

export default defineNuxtRouteMiddleware((to) => {
  const brandsStore = useBrandsStore()

  if (!brandsStore.isLoaded) {
    return
  }

  if (to.params.orderType !== OrderTypeEnum.PREORDER) {
    return
  }

  if (normalizeRouteName(to.name) === 'landing') {
    return
  }

  const brandIdResult = routeParamResult(parseIdParam({ name: 'brandId', param: to.params.brandIdAndSlug }))
  if (!brandIdResult.ok) {
    return
  }

  const brand = brandsStore.getBrand(brandIdResult.data)
  if (!checkPreOrderBlocked(brand)) {
    return
  }

  return navigateTo(
    useRoutePath().landing({
      brandId: brandIdResult.data,
      orderType: OrderTypeEnum.PREORDER,
    }),
  )
})
